import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from '../../../components/Loader';
import moment from 'moment'
import getExcel from "../../../_services/ExcelUtility";
const ProcessPendingFilesPage = () => {
    const fileName = 'Process Pending Files'
    const [startDate, setStartDate] = useState(new Date());
    const [processPendingFiles, setProcessPendingFiles] = useState([]);
    const [loading, setLoading] = useState(false);

    let filterStartDate = moment(startDate).format("L")
    const [validated, setValidated] = useState(false)
    const [btnDisable, setBtnDisable] = useState(true)
    const [greaterErr, setGreaterErr] = useState(false)
    const [emptyErr, setEmptyErr] = useState(false)
    const [processPendingError, setProcessPendingError] = useState(false)

    useEffect(() => {
        getProcessPendingFIles();
    }, []);

    const columns = [
        {
            Header: "Actions",
            accessor: 'accessor',
            disableFilters: true,
            disableSortBy: true, width: 135,
            Cell: ({ row: { original } }) => (
                <Fragment>
                    <Button type="submit" className="mt-1 mb-1" onClick={() => processFile(original.FileProcessId)}   >
                        {/* <IoMdRefresh className="icon" /> */}Process Now
                    </Button>
                </Fragment>
            )
        },
        {
            Header: "Task Name",
            accessor: "TaskName",
            filter: "TaskName",
            sortType: "basic", width: 190
        },
        {
            Header: "File Name",
            accessor: "FileProcessName",
            filter: "FileProcessName",
            sortType: "basic", width: 270,
            Cell: ({ row: { original } }) => (
                <Fragment>
                    <span className="word-wrap">{original.FileProcessName}</span>
                </Fragment>
            )
        },
        {
            Header: "Source",
            accessor: "FileSourceTypeId",
            filter: "FileSourceTypeId",
            sortType: "basic", width: 110
        },
        {
            Header: "File Format",
            accessor: "FileFormatName",
            filter: "FileFormatName",
            sortType: "basic"
        },
        {
            Header: "File Received/Generated Date and Time",
            accessor: "FileProcessRcvdDate",
            filter: "FileProcessRcvdDate",
            sortType: "basic", width: 170
        },
        {
            Header: "Process Start Date & Time",
            accessor: "FileProcessStartDate",
            filter: "FileProcessStartDate",
            sortType: "basic", width: 170
        },
        {
            Header: "Status",
            accessor: "FileProcessStatus",
            filter: "FileProcessStatus",
            sortType: "basic",
            Cell: ({ row: { original } }) => (
                <Fragment>
                    <span className="word-wrap">{original.FileProcessStatus}</span>
                </Fragment>
            )
        }
    ];

    const getProcessPendingFIles = () => {
        setLoading(true);
        _HttpServices
            .postData(`Api/Chart/GetFileProcessesDataByTask_partial?date=${filterStartDate}&StatusId=0&taskId=0&page=0&searchBy=""&searchText=""`)
            .then((data) => {
                const processPendingResult = data.data.LstFileProcessVM;
                if (processPendingResult.length > 0) {
                    processPendingResult.map((res) => {
                        res.FileProcessRcvdDate = moment(res.FileProcessRcvdDate).format('MM/DD/YYYY h:mm:ss A')
                        res.FileProcessStartDate = moment(res.FileProcessStartDate).format('MM/DD/YYYY h:mm:ss A')
                        res.FileSourceTypeId = res.FileSourceTypeId == 1 ? "Inbound" : "Outbound";
                    })
                }
                setProcessPendingFiles(processPendingResult);
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setProcessPendingError(true)
            })
    }

    const submitHandler = (e) => {
        e.preventDefault()
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
            setValidated(true)
        } else {
            e.preventDefault()
            if (startDate === 0) {
                setEmptyErr(true)
                return false
            }

            filterStartDate = moment(startDate).format("L")

            getProcessPendingFIles()
            setBtnDisable(true)
            setValidated(false)
        }
    }
    const processFile = (fileProcessID) => {
        setLoading(true);
        _HttpServices
            .getData(`Api/Chart/ImmidiateFileProcess?FileProcessId=${fileProcessID}`)
            .then((data) => {
                setProcessPendingFiles(processPendingFiles.filter((data) => { return data.FileProcessId !== fileProcessID }))
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
            });
    }
    return (
        <Row>
            <Col md={12}>
                <div className="card pt-2 mb-4">
                    <div className="card-body">
                        {processPendingFiles.length > 0 ?
                            <Button type="button" className="dashboard-excel-btn" onClick={() => getExcel(columns, processPendingFiles, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                            : null}
                        <Form noValidate validated={validated} onSubmit={submitHandler}>
                            <Row>
                                <Col md={3}>
                                    <Form.Group>
                                        <div className="date-picker ungroup-date-picker pos-rl">
                                            <Form.Label htmlFor="StartDate">
                                                Date
                </Form.Label>
                                            <IoMdCalendar className="icon date-icon" />
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => {
                                                    if (date) {
                                                        setBtnDisable(false)
                                                        return setStartDate(date)
                                                    } else {
                                                        setBtnDisable(true)
                                                    }
                                                }}
                                                maxDate={new Date()}
                                                required
                                                className={emptyErr ? "form-control is-invalid" : "form-control"}
                                            />
                                            {emptyErr ? <div className="err-feedback">Please select Start Date.</div> : null}
                                            {/* {greaterErr ? <div className="err-feedback">Since should not be greater than until date.</div> : null} */}
                                        </div>
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group className="mt-2">
                                        <Button type="submit" className="mt-3"
                                            disabled={btnDisable}
                                        >
                                            <IoMdDoneAll className="icon btn-icon" />
                                            Submit
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div>
                <div className="card pt-2">
                    <div className="card-body">
                        <div className="inventory-grid">
                            <Fragment>
                                {loading ? <Loader /> : processPendingFiles.length > 0 ? (
                                    <ReactTable columns={columns} data={processPendingFiles} defaultPageSize={10} />
                                ) : processPendingError ? <p>Error occurred. Unable to load queue files.</p> : (
                                    <div className="no-data">No data found.</div>
                                )}
                            </Fragment>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    )
}

export default ProcessPendingFilesPage;